import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'

export default class Header extends TemplateView {
    constructor({
        messageKey
    }) {
        super()

        this.state = {
            name: ''
        }

        this.onStatePropertyChanged('name', name => {
            this.$el.text(messageResource.getMessage(messageKey, [name]))
        })
    }

    templateHtml() {
        return "<div class='header'></div>"
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/Header.js